import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWandb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.86045 5.32558C4.21826 5.32558 3.69766 4.80498 3.69766 4.16279C3.69766 3.5206 4.21826 3 4.86045 3C5.50264 3 6.02324 3.5206 6.02324 4.16279C6.02324 4.80498 5.50264 5.32558 4.86045 5.32558Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.86043 10.6744C3.83295 10.6744 3 9.8415 3 8.81401C3 7.78652 3.83295 6.95358 4.86043 6.95358C5.88792 6.95358 6.72087 7.78652 6.72087 8.81401C6.72087 9.8415 5.88792 10.6744 4.86043 10.6744Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.86043 19.9765C3.83295 19.9765 3 19.1435 3 18.1161C3 17.0886 3.83295 16.2556 4.86043 16.2556C5.88792 16.2556 6.72087 17.0886 6.72087 18.1161C6.72087 19.1435 5.88792 19.9765 4.86043 19.9765Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.69766 13.4652C3.69766 14.1074 4.21826 14.628 4.86045 14.628C5.50264 14.628 6.02324 14.1074 6.02324 13.4652C6.02324 12.823 5.50264 12.3024 4.86045 12.3024C4.21826 12.3024 3.69766 12.823 3.69766 13.4652Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1394 15.186C10.1394 16.2135 10.9723 17.0465 11.9998 17.0465C13.0273 17.0465 13.8603 16.2135 13.8603 15.186C13.8603 14.1585 13.0273 13.3256 11.9998 13.3256C10.9723 13.3256 10.1394 14.1585 10.1394 15.186Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 21C11.3577 21 10.8371 20.4794 10.8371 19.8372C10.8371 19.195 11.3577 18.6744 11.9999 18.6744C12.642 18.6744 13.1626 19.195 13.1626 19.8372C13.1626 20.4794 12.642 21 11.9999 21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8371 10.5348C10.8371 11.177 11.3577 11.6976 11.9999 11.6976C12.642 11.6976 13.1626 11.177 13.1626 10.5348C13.1626 9.89261 12.642 9.37201 11.9999 9.37201C11.3577 9.37201 10.8371 9.89261 10.8371 10.5348Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 7.04639C11.3577 7.04639 10.8371 6.52579 10.8371 5.8836C10.8371 5.24141 11.3577 4.72081 11.9999 4.72081C12.642 4.72081 13.1626 5.24141 13.1626 5.8836C13.1626 6.52579 12.642 7.04639 11.9999 7.04639Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.279 8.81401C17.279 9.8415 18.1119 10.6744 19.1394 10.6744C20.1669 10.6744 20.9999 9.8415 20.9999 8.81401C20.9999 7.78652 20.1669 6.95358 19.1394 6.95358C18.1119 6.95358 17.279 7.78652 17.279 8.81401Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1394 5.32558C18.4973 5.32558 17.9767 4.80498 17.9767 4.16279C17.9767 3.5206 18.4973 3 19.1394 3C19.7816 3 20.3022 3.5206 20.3022 4.16279C20.3022 4.80498 19.7816 5.32558 19.1394 5.32558Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9767 13.4652C17.9767 14.1074 18.4973 14.628 19.1394 14.628C19.7816 14.628 20.3022 14.1074 20.3022 13.4652C20.3022 12.823 19.7816 12.3024 19.1394 12.3024C18.4973 12.3024 17.9767 12.823 17.9767 13.4652Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1394 19.2788C18.4973 19.2788 17.9767 18.7582 17.9767 18.116C17.9767 17.4738 18.4973 16.9532 19.1394 16.9532C19.7816 16.9532 20.3022 17.4738 20.3022 18.116C20.3022 18.7582 19.7816 19.2788 19.1394 19.2788Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconWandb as ReactComponent };
